import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'How much does a man and van service cost?',
      answer: 'Our pricing starts from £60 for small van collections. Hourly rates for all Luton van removals begin at £60 for one man and a van and £80 for full-service moves with two men with a 3 hour minimum booking required. The final cost depends on factors like congestion charge, Toll fee and any additional services required. Contact us for a free, personalized quote.'
    },
    {
      question: 'Are you insured and licensed?',
      answer: 'Yes, we are fully insured and licensed. We carry comprehensive goods in transit insurance and public liability insurance to protect your belongings during the move. All our drivers are properly licensed and our vans are regularly maintained and inspected.'
    },
    {
      question: 'How far in advance should I book?',
      answer: 'We recommend booking at least 1-3 days in advance, especially for weekends and month-end moves. However, we understand that sometimes moves come up unexpectedly, so we also offer same-day and next-day services subject to availability.'
    },
    {
      question: 'Do you provide packing materials?',
      answer: 'Yes, we can provide all necessary packing materials including boxes, bubble wrap, packing tape, and furniture blankets. These can be included in your quote or purchased separately. We also offer a full packing service if you prefer us to handle everything.'
    },
    {
      question: 'What items can you move?',
      answer: 'We can move almost anything including furniture, appliances, boxes, office equipment, and single items. We specialize in house removals, office moves, and marketplace collections. However, we cannot transport hazardous materials, illegal items, or live animals.'
    },
    {
      question: 'Do you work on weekends and evenings?',
      answer: 'Absolutely! We offer flexible scheduling including evenings, weekends, and bank holidays. This is particularly useful for office moves that need to happen outside business hours to minimize disruption.'
    },
    {
      question: 'What happens if something gets damaged?',
      answer: 'While we take every precaution to prevent damage, accidents can happen. That\'s why we\'re fully insured. If any item is damaged during the move, our insurance will cover the repair or replacement. Simply report any damage within 24 hours of your move.'
    },
    {
      question: 'Can you help with furniture assembly?',
      answer: 'Yes, we offer furniture disassembly and reassembly services. Our team can take apart larger items for safe transport and reassemble them at your new location. This service can be added to your quote.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-300">
            Got questions? We've got answers. Find everything you need to know about our services.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-700 rounded-lg overflow-hidden border border-gray-600"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-600 transition-colors cursor-pointer"
              >
                <span className="text-lg font-semibold text-white pr-8">{faq.question}</span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-300 flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5 pt-2">
                  <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
